export const media = {
  xxsmall: '300px',
  xsmall: '350px',
  small: '375px',
  medium: '600px',
  large: '900px',
  portrait:
    '@media (min-width: 600px) and (orientation: portrait), (min-width: 800px)',
};
